import { gql } from '@apollo/client'

export const GetSupportingDocuments = gql`
    query getSupportingDocuments(
        $getSupportingDocsInput: GetSupportingDocumentsInput!
    ) {
        getSupportingDocuments(input: $getSupportingDocsInput) {
            supportingDocument
        }
    }
`

export const HasSupportingDocuments = gql`
    query hasSupportingDocument(
        $getSupportingDocsInput: GetSupportingDocumentsInput!
    ) {
        hasSupportingDocument(input: $getSupportingDocsInput)
    }
`
